export const BITS_PER_MASK = 32;

export function bitMask(idx: number): number {
  return (1 << idx) >>> 0;
}

export function bitMaskNot(idx: number): number {
  return ~(1 << idx) >>> 0;
}
